import api from '@/store/helpers/api';
import i18n from '@/i18n';

const initialState = () => ({
  isLoading: false,
  push: false,
  lang: 'es',
  year: null,
  preEvaluated: false,
  preEvaluatedRondo: false,
  preEvaluatedTinder: false,
  preEvaluatedQuiz: false,
  preEvaluatedSearch: false,
  postEvaluated: false,
});

const getters = {};

const actions = {
  set({ commit }, {
    push,
    lang,
    pic,
    year,
    preEvaluated,
    preEvaluatedRondo,
    preEvaluatedTinder,
    preEvaluatedQuiz,
    preEvaluatedSearch,
    postEvaluated,
  }) {
    commit('SET_PUSH', push);
    commit('SET_LANG', lang);
    commit('SET_YEAR', year);
    commit('SET_EVAL', {
      preEvaluated,
      postEvaluated,
      preEvaluatedRondo,
      preEvaluatedTinder,
      preEvaluatedQuiz,
      preEvaluatedSearch,
    });
    if (pic) {
      commit('session/SET_PIC', pic, { root: true });
    }
  },
  store({ commit, dispatch, state }, {
    push,
    lang,
    pic,
    year,
    preEvaluated,
    preEvaluatedRondo,
    preEvaluatedTinder,
    preEvaluatedQuiz,
    preEvaluatedSearch,
    postEvaluated,
  }) {
    if (state.isLoading) {
      return false;
    }

    dispatch('set', {
      push,
      lang,
      pic,
      year,
      preEvaluated,
      preEvaluatedRondo,
      preEvaluatedTinder,
      preEvaluatedQuiz,
      preEvaluatedSearch,
      postEvaluated,
    });

    commit('LOADING');
    return api.post('settings', {
      push,
      lang,
      pic,
      year,
      preEvaluated,
      preEvaluatedRondo,
      preEvaluatedTinder,
      preEvaluatedQuiz,
      preEvaluatedSearch,
      postEvaluated,
    })
      .finally(() => commit('LOADEND'))
      .catch((error) => {
        console.error('Error storing settings', error);
      });
  },
  reset({ commit }) {
    commit('RESET');
  },
};

const mutations = {
  LOADING(state) {
    state.isLoading = true;
  },
  LOADEND(state) {
    state.isLoading = false;
  },
  LOGIN(state, token) {
    api.defaults.headers.common = { Authorization: `Bearer ${token}` };
    state.isLogged = true;
  },
  SET_PUSH(state, data) {
    if (typeof data === 'undefined') {
      return false;
    }

    state.push = !!data;
    return data;
  },
  SET_LANG(state, data) {
    if (typeof data !== 'string') {
      return false;
    }

    i18n.locale = data;
    state.lang = data;
    return data;
  },
  SET_YEAR(state, data) {
    if (typeof data === 'number') {
      state.year = data;
    }
    return data;
  },
  SET_EVAL(state, data) {
    if (data.preEvaluated) {
      state.preEvaluated = true;
    }
    if (data.preEvaluatedRondo) {
      state.preEvaluatedRondo = true;
    }
    if (data.preEvaluatedTinder) {
      state.preEvaluatedTinder = true;
    }
    if (data.preEvaluatedQuiz) {
      state.preEvaluatedQuiz = true;
    }
    if (data.preEvaluatedSearch) {
      state.preEvaluatedSearch = true;
    }
    if (data.postEvaluated) {
      state.postEvaluated = true;
    }
    return data;
  },
  RESET(state) {
    const blankState = initialState();
    const keys = Object.keys(blankState);
    keys.forEach((key) => {
      state[key] = blankState[key];
    });
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
};
